import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    users: null,
    newusers: null,
}

const adminUsersSlice = createSlice({
    name: "adminusers",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeUsers: (state, action) => {
            state.users= action.payload;
        },
        editAdminUserInStore: (state, action) => {
            let records= state.users&&state.users.records.map((user)=>{
                if(action.payload && user.id === action.payload.id){
                    return action.payload
                }else{
                    return user
                }
            })
            state.users= {...state.users, records: records}
        },
        storeNewUsers: (state, action) => {
            state.newusers= action.payload;
        },
        editAdminNewUserInStore: (state, action) => {
            let records= state.newusers&&state.newusers.records.map((user)=>{
                if(action.payload && user.id === action.payload.id){
                    return action.payload
                }else{
                    return user
                }
            })
            state.newusers= {...state.newusers, records: records}
        }
    }
})

export const { storeUsers, editAdminUserInStore, storeNewUsers, editAdminNewUserInStore } = adminUsersSlice.actions
export default adminUsersSlice.reducer